<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<mat-horizontal-stepper *ngIf="experimentToView && action && steps.length>0"
  [selectedIndex]="initialStep" (selectionChange)="selectionChanged($event)">
  <ng-template matStepperIcon="edit">
    <mat-icon>science</mat-icon>
  </ng-template>
  <mat-step *ngFor="let step of steps" label="{{step}}" [completed]="true"/>
</mat-horizontal-stepper>